import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    getBranches,
    getExpenseCategories
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
class ExpenseAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            branches: [],
            loading: false,
            formData: {
                category_id: '',
                branch_id: '',
                description: '',
                type: 'Gider',
                amount: '',
                expense_date: '',
            }
        }
    }
    async componentDidMount() {
        try {
            this.setState({
                branches: await getBranches(),
                categories: await getExpenseCategories() || []
            });
        } catch (e) {
            throw e;
        }
    }
    handleChange = (e) => {
        const { id, value } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: value
            }
        }));
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const expenseFormData = new FormData();
        Object.keys(formData).forEach(key => {
            expenseFormData.append(key, formData[key]);
        });
        try {
            const response = await apiCall('business/expense/add', 'post', expenseFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message);
        } catch (e) {
            this.setState({ loading: false });

        }
    }
    render() {
        const { loading, branches, categories } = this.state;
        const { userPermissions } = this.props;
        const userHasNewExpensePermission = userPermissions.includes('new expense');
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Yeni Gider Ekle"
                            Breadcrumb={[
                                { name: "Gelir Gider Takibi", navigate: "" },
                                { name: "Giderler", navigate: "expenses" },
                                { name: "Yeni Gider", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="body">
                                            <h6>Yeni Gider Ekle</h6>
                                            <div className="row clearfix">
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="category_id"
                                                            className="font-weight-bold text-cyan">
                                                            &nbsp;
                                                        </label>
                                                        <select id='category_id'
                                                            className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Kategori Seçiniz</option>
                                                            {categories && (categories.map(category => (
                                                                <option key={category.id}
                                                                    value={category.id}>{category.name}</option>
                                                            )))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="branch_id"
                                                            className="font-weight-bold text-cyan">
                                                            &nbsp;
                                                        </label>
                                                        <select id='branch_id'
                                                            className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Şube Seçiniz</option>
                                                            {branches && (branches.map(branch => (
                                                                <option key={branch.id}
                                                                    value={branch.id}>{branch.name}</option>
                                                            )))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <textarea
                                                            id="description"
                                                            className="form-control"
                                                            placeholder="Gider bilgisi"
                                                            onChange={this.handleChange}>
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <input
                                                            id="amount"
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Tutar giriniz"
                                                            onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="category_id"
                                                            className="font-weight-bold text-cyan">
                                                            Gider Tarihi
                                                        </label>
                                                        <input
                                                            id="expense_date"
                                                            type="date"
                                                            className="form-control"
                                                            onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="body">
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">

                                                    {loading ? (
                                                        <button className="btn btn-outline-primary btn-block"
                                                            disabled={true}
                                                            style={{ textAlign: "-webkit-center" }}>
                                                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                                                        </button>
                                                    ) :
                                                        <button disabled={!userHasNewExpensePermission}
                                                            className="btn btn-outline-primary btn-block"
                                                            type="submit">
                                                            Kaydet
                                                        </button>}

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(ExpenseAdd)));
